onComplete(function () {
	// const blogOverviews = document.querySelectorAll(".blog-overview");

	// blogOverviews.forEach(function (el) {
	// 	if (el.querySelector('a[href*="agenda"]')) {
	// 		el.classList.add("blog-template-agenda");
	// 	}
	// });
});